export default function validate (values) {
  const errors = {};
  if (!values.reason) {
    errors.reason = { _error: 'Alasan harus diisi' };
  }
  return errors;
}
